export default "__VITE_ASSET__4194743a__"